import cx from "classnames"
import { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from "react-i18next"
import { Button, buttonSizes, buttonColors, WalletIcon } from "@tutellus/tutellus-components"
import { useEthereum } from "../../../context"
import { NavBar } from "../../Layout/NavBar"
import { HeaderLogo } from "../../Layout/HeaderLogo"
import { WalletModalButton } from "../../Layout/WalletModalButton"
import styles from "./index.module.css"

export const Topbar = () => {
  const { isWalletConnected } = useEthereum()
  const { t } = useTranslation("common")
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className={cx(styles.container, { [styles.scrolled]: isScrolled })}>
      <div className={styles.innerContainer}>
        <HeaderLogo />

        <NavBar />

        <div className={styles.buttonsContainer}>
          {isWalletConnected ? (
            <WalletModalButton />
          ) : (
            <Link to="/connect">
              <Button size={buttonSizes.SMALL} color={buttonColors.PRIMARY} iconLeft={<WalletIcon />} hideTextOnMobile>
                {t("connect")}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
